<template>
  <div class="my-10">
    <div class="flex max-lg:flex-col gap-4 mb-20">
      <div class="flex flex-col divide-y">
        <div>
          <!-- <div v-if="isVideo">
                        <video controlsList="nodownload" controls :src="detail?.thumbnail"
                        class="object-contain  w-full h-[31.25rem]" alt=""></video>
                    </div>
                    <div v-else class="mb-4">
                        <img :src="detail?.thumbnail" class="h-full rounded-md  w-full" alt="">
                    </div> -->
          <div v-if="bannersLoaded">
            <Splide
              @splide:move="stopVideo"
              ref="splide"
              class="w-full"
              :options="{
                perPage: 1,
                padding: 0,
                autoplay: false,
                pagination: false,
                pauseOnHover: false,
              }"
              :has-track="false"
              aria-label="similars"
            >
              <SplideTrack class="py-4">
                <SplideSlide
                  v-for="el in detail?.medias"
                  :id="`video${el.id}`"
                  :key="keyvideo[`video${el.id}`]"
                >
                  <video
                    controlsList="nodownload"
                    v-if="isVideo(el.path)"
                    :ref="'video' + el.id"
                    controls
                    :src="el?.path"
                    class="object-contain h-[31.25rem] w-full"
                  ></video>
                  <img
                    v-else
                    class="rounded-t h-[31.25rem] w-full object-contain"
                    :src="el?.path"
                    alt="store-banner"
                  />
                </SplideSlide>
              </SplideTrack>
            </Splide>
          </div>
          <p
            class="bg-[#409DBA] text-white text-xs px-2 py-1 inline-block mb-1"
            v-if="detail?.category"
          >
            {{ detail?.category }}
          </p>

          <div class="flex justify-between items-center mb-3">
            <p class="text-xl text-main-color w-[41.875rem] font-semibold">{{ detail?.name }}</p>
          </div>

          <div class="flex justify-between items-center text-main-color">
            <p class="font-light text-sm">{{ detail?.date_created }}</p>
            <div class="flex items-center gap-1">
              <IconEye />
              <p class="text-sm font-semibold">{{ detail?.view_count }}</p>
            </div>
          </div>
          <div class="mt-2">
            <template v-if="detail?.link_type != null">
              <a
                v-if="detail?.link_type == 0"
                :href="getExternalLink(detail?.link)"
                target="_blank"
                rel="noopener noreferrer"
                class="text-lg overflow-hidden truncate text-[#409DBA] font-semibold mb-3 md:mb-0 hover:text-main-color"
              >
                {{ detail?.link_text }}
              </a>
              <router-link
                v-else
                :to="{ name: linkType[detail?.link_type].route, params: { id: detail?.link } }"
                class="text-lg overflow-hidden truncate text-[#409DBA] font-semibold mb-3 md:mb-0 hover:text-main-color"
                >{{ detail?.link_text }}
              </router-link>
            </template>
          </div>
        </div>

        <div>
          <div class="flex justify-end my-3">
            <button
              :disabled="loading"
              class="rounded-full bg-[#409DBA] h-[2.1875rem] w-[2.1875rem] flex justify-center items-center cursor-pointer"
              @click="likeAction"
            >
              <IconHeart :class="{ 'fill-white': this.isLiked }"></IconHeart>
            </button>
          </div>
        </div>

        <div class="w-full">
          <PosterBannerSmall
            class="my-5"
            v-if="publicationSmallPosters.length > 0"
            :content="publicationSmallPosters"
          />

          <div class="text-[#333] text-xl font-light mb-6 md:mb-16" v-html="detail?.content"></div>

          <PosterBannerSmall
            class="my-5 [&>img]:!h-96"
            v-if="bigPoster.length > 0"
            :content="bigPoster"
          />

          <div>
            <p class="text-xl text-main-color font-semibold mb-3">{{ $t('page.tags') }}</p>
            <div class="flex gap-3">
              <router-link
                :to="{ name: 'newsSearch', query: { searchQuery: tag, isTag: true } }"
                class="bg-[#D9D9D9] font-light text-base text-main-color py-2 px-3 rounded"
                v-for="(tag, index) in detail?.tags"
                :key="index"
                >#{{ tag }}</router-link
              >
            </div>
          </div>
        </div>
        <p
          v-if="
            recommendations?.mall_stores?.length > 0 &&
            recommendations?.exhibition_stores?.length > 0 &&
            recommendations?.business_accounts?.length > 0
          "
          class="mt-10 font-semibold text-main-color text-3xl"
        >
          {{ $t('page.selecteds') }}
        </p>
        <div class="mt-5" v-if="recommendations?.mall_stores?.length > 0">
          <div class="grid grid-cols-3 gap-5 max-lg:grid-cols-2 max-md:grid-cols-2">
            <router-link
              v-for="item in recommendations?.mall_stores"
              :key="item?.id"
              :to="{ name: 'storeDetail', params: { id: item?.id } }"
            >
              <StoreCard :detail="item"></StoreCard>
            </router-link>
          </div>
        </div>

        <div class="mt-5" v-if="recommendations?.exhibition_stores?.length > 0">
          <div class="grid grid-cols-3 gap-5 max-lg:grid-cols-2 max-md:grid-cols-2">
            <router-link
              v-for="item in recommendations?.exhibition_stores"
              :key="item?.id"
              :to="{ name: 'foodRestaurantDetail', params: { id: item?.id } }"
            >
              <StoreCard :detail="item"> </StoreCard>
            </router-link>
          </div>
        </div>

        <div class="mt-5" v-if="recommendations?.business_accounts?.length > 0">
          <div class="grid grid-cols-3 gap-5 max-lg:grid-cols-2 max-md:grid-cols-2">
            <router-link
              v-for="item in recommendations?.business_accounts"
              :key="item.id"
              :to="{ name: 'businessAccountsDetail', params: { id: item.id } }"
            >
              <BusinessAccountCard :detail="item"> </BusinessAccountCard>
            </router-link>
          </div>
        </div>
      </div>

      <div class="flex flex-col max-lg:mt-20">
        <p class="text-main-color text-2xl font-semibold mb-3">{{ $t('page.similars') }}</p>
        <div class="flex flex-col gap-3">
          <router-link
            v-for="(news, index) in similarNews"
            :key="news.id"
            :to="{ name: 'newsDetail', params: { id: news.id } }"
          >
            <NewsCard :detail="news" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, getExternalLink, isVideo } from '@/helpers';
import IconEye from '@icons/IconEye.vue';
import IconHeart from '@icons/IconHeart.vue';
import PosterBannerSmall from '@cmp/PosterBannerSmall.vue';
import NewsCard from '@cmp/media/NewsCard.vue';
import StoreCard from '@cmp/mall/StoreCard.vue';
import BusinessAccountCard from '@cmp/media/BusinessAccountCard.vue';
import api from '@/api';
import { LINK_TYPE } from '@/constants';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';

export default {
  name: 'newsDetail',
  components: {
    IconEye,
    IconHeart,
    PosterBannerSmall,
    NewsCard,
    StoreCard,
    BusinessAccountCard,
    Splide,
    SplideSlide,
    SplideTrack,
  },
  watch: {
    '$route.params.id': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.currentId = newValue;
          this.getNewsDetail();
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      detail: null,
      isLiked: false,
      publicationSmallPosters: [],
      bigPoster: [],
      similarNews: [],
      linkType: LINK_TYPE,
      recommendations: [],
      keyvideo: {},
      bannersLoaded: false,
    };
  },
  methods: {
    formatDate,
    getExternalLink,
    isVideo,
    async getNewsDetail() {
      this.loading = true;
      try {
        const response = await api.get(`posts/announcements/${this.currentId}/`);
        this.detail = response.data;
        this.isLiked = this.detail.is_liked;
        this.bannersLoaded = true;
        await this.getSimilarNews();
        await this.getRecommendations();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    async getSimilarNews() {
      this.loading = true;
      try {
        const response = await api.get(`posts/announcements/?category=${this.detail?.category_id}`);
        this.similarNews = response.data.results;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    async getPublicationSmallPoster() {
      try {
        const response = await api.get('commercials/advertisements/?type=210');
        this.publicationSmallPosters = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getBigPoster() {
      try {
        const response = await api.get('commercials/advertisements/?type=211');
        this.bigPoster = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getRecommendations() {
      try {
        const response = await api.get(
          `posts/announcements/categories/${this.detail?.category_id}/recommendations/`,
        );
        this.recommendations = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async likeAction() {
      if (this.$store.authStatus === false) {
        this.$store.setState('loginModal', true);
        return;
      }
      try {
        this.loading = true;
        const response = await api.post(`posts/announcements/${this.currentId}/like/`, {
          is_liked: !this.isLiked,
        });
        this.isLiked = !this.isLiked;
        this.$store.getLiked('announcements');
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    stopVideo() {
      this.detail?.medias.forEach(element => {
        if (this.isVideo(element.path)) {
          let v = 'video' + element.id;
          this.keyvideo[v] += 1;
        }
      });
    },
  },
  computed: {},
  async created() {
    this.currentId = this.$route.params.id;
    await this.getNewsDetail();
    await this.getPublicationSmallPoster();
    await this.getBigPoster();
  },
};
</script>
